import React from "react";

const CoordsCellRenderer = (props) => {
    const { value } = props;


    function toDMS(deg, isLat) {
      if(!deg) return "";

      const direction = deg >= 0
        ? (isLat ? 'N' : 'E')
        : (isLat ? 'S' : 'W');

      const absDeg = Math.abs(deg);
      const d = Math.floor(absDeg);
      const mFloat = (absDeg - d) * 60;
      const m = Math.floor(mFloat);
      const s = ((mFloat - m) * 60).toFixed(1); // one decimal place

      return `${direction} ${d}°${m}'${s}"`;
    }


    return (
        <div className="double-renderer-outer">
          <div className="double-renderer-field">
              {toDMS(value?.latitude, true)}
          </div>
          <div className="double-renderer-field">
              {toDMS(value?.longitude, false)}
          </div>
        </div>
    );
};

export default CoordsCellRenderer;
